// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Epithalon 09.17.26" (15ca52c4-65b8-48f7-a2c8-d5ff78a9b62a). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiEpithalonQuestions = [
  {
    field: 'mdiEpithalon_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiEpithalon_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiEpithalon_wereSorryTreatmentNotMedically',
    label:
      "We're sorry, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '7bfffa23-1627-4129-9fe8-05dfdff901af',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiEpithalon_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: Please click the attached link to review the consent for your peptide therapy treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the Peptide therapy consent (https://drive.google.com/file/d/1wQRV8pzuaBPIwGRy_0KnJfhQTS2OL0S-/view)',
    answer: {
      type: 'text',
      name: 'mdiEpithalon_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: 'b32df1fd-e190-42f3-8bda-7a6834c758ad' }
  },
  {
    field: 'mdiEpithalon_reasonInterestedPeptide',
    label: 'What is the reason you are interested in this peptide?',
    type: 'select',
    educationalSlide: 'Select all that apply',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'cellular_longevity_and_anti_aging',
          value: 'Cellular longevity and anti-aging'
        },
        {
          key: 'telomere_length_preservation',
          value: 'Telomere length preservation'
        },
        {
          key: 'sleep_quality_improvement_and_circadian',
          value: 'Sleep quality improvement and circadian rhythm regulation'
        },
        {
          key: 'age_related_cognitive_decline',
          value: 'Age-related cognitive decline'
        },
        {
          key: 'skin_aging_and_tissue_regeneration',
          value: 'Skin aging and tissue regeneration'
        },
        {
          key: 'immune_system_function_optimization',
          value: 'Immune system function optimization'
        },
        {
          key: 'oxidative_stress_reduction',
          value: 'Oxidative stress reduction'
        },
        {
          key: 'melatonin_production_enhancement',
          value: 'Melatonin production enhancement'
        },
        {
          key: 'age_related_hormonal_imbalances',
          value: 'Age-related hormonal imbalances'
        },
        {
          key: 'general_healthspan_and_wellness_optimiza',
          value: 'General healthspan and wellness optimization'
        },
        {
          key: 'periodontal_and_gingival_tissue_health',
          value: 'Periodontal and gingival tissue health'
        },
        {
          key: 'recovery_and_regeneration_support',
          value: 'Recovery and regeneration support'
        }
      ]
    },
    extras: { mdiQuestionId: '3920b02f-04f3-4bc0-a87e-ff037f815bdf' }
  },
  {
    field: 'mdiEpithalon_everUsedPeptideTherapiesPast',
    label: 'Have you ever used peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'acd77ae3-acf0-4e88-8c4f-46a3e5e334db' }
  },
  {
    field: 'mdiEpithalon_peptidesUsedPreviously',
    label: 'What peptides have you used previously?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiEpithalon_peptidesUsedPreviously',
      rows: 4
    },
    extras: { mdiQuestionId: 'cc2af85e-d5e4-480f-a7a7-f8424c48635d' }
  },
  {
    field: 'mdiEpithalon_everReactionSideEffectsPeptide',
    label:
      'Have you ever had a reaction or side effects to peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '432a1d41-57a6-47e9-a724-a966ef06f20b' }
  },
  {
    field: 'mdiEpithalon_reactionSideEffect',
    label: 'What was your reaction or side effect?',
    type: 'info',
    answer: { type: 'text', name: 'mdiEpithalon_reactionSideEffect', rows: 4 },
    extras: { mdiQuestionId: '202100a1-a676-4138-95d1-557a9ac704bb' }
  },
  {
    field: 'mdiEpithalon_diagnosedRedFlagMedicalConditions',
    label:
      'Do you currently have or have you been diagnosed with any of the following red flag medical conditions listed below that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'cancer', value: 'Cancer' },
        {
          key: 'cardiovascular_disease_such_as_heart_att',
          value: 'Cardiovascular disease such as heart attack, stroke, etc'
        },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        { key: 'autoimmune_disease', value: 'Autoimmune disease' },
        { key: 'psychiatric_illness', value: 'Psychiatric illness' },
        { key: 'suicidal_thoughts', value: 'Suicidal thoughts' },
        { key: 'seizure_disorder', value: 'Seizure disorder' },
        { key: 'immunodeficiency', value: 'Immunodeficiency' },
        { key: 'organ_transplant', value: 'Organ transplant' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'ba99fdea-3255-4d1a-b015-0447c83a0468' }
  },
  {
    field: 'mdiEpithalon_confirmNotHistoryCancerKidney',
    label:
      'Please confirm you do not have any history of cancer, kidney or liver disease:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_agree_i_do_not_have_any_history_of_can',
          value:
            'I agree, I do NOT have any history of cancer, kidney or liver disease'
        },
        {
          key: 'i_have_been_diagnosed_with_cancer_or_hav',
          value:
            'I HAVE been diagnosed with cancer or have had problems with my kidneys or liver previously'
        }
      ]
    },
    extras: { mdiQuestionId: 'd0fae73f-cbc3-449e-9952-28bf628a80a4' }
  },
  {
    field: 'mdiEpithalon_takeRedFlagMedicationsSubstances',
    label:
      'Do you take any of the following red flag medications or substances that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'chemotherapy_or_oncology_treatments',
          value: 'Chemotherapy or oncology treatments'
        },
        { key: 'melatonin', value: 'Melatonin' },
        {
          key: 'sedatives_such_as_benzodiazepines_sleep',
          value: 'Sedatives such as benzodiazepines, sleep aids, etc'
        },
        { key: 'antipsychotics', value: 'Antipsychotics' },
        {
          key: 'mood_stabilizers_such_as_lithium',
          value: 'Mood stabilizers (such as lithium)'
        },
        { key: 'thyroid_medication', value: 'Thyroid medication' },
        {
          key: 'steroids_glucocorticoids_like_prednisone',
          value: 'Steroids (glucocorticoids like prednisone)'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '76e8ce9d-9897-4933-a2b1-b9a70b47ac12' }
  },
  {
    field: 'mdiEpithalon_allergyBenzylPeroxide',
    label: 'Do you have an allergy to benzyl peroxide?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '4f90ad5d-8edb-4941-8aa1-8651db31192a' }
  },
  {
    field: 'mdiEpithalon_lastTimePersonMedicalEvaluation',
    label: 'When was the last time you had an in-person medical evaluation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_2_years_ago', value: '1-2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: '204b394c-cf7d-4988-8698-e0bc73acdcbe' }
  },
  {
    field: 'mdiEpithalon_confirmUnderstandContactDoctorQuestions',
    label:
      'Please confirm the following: I understand and will contact my doctor if I have any questions',
    type: 'info',
    subLabel:
      'I understand that this peptide therapy is for use as a subcutaneous injection. I understand I will have to draw up and administer this injection myself. I understand that administering incorrectly or the wrong amount of this peptide therapy may cause serious side effects. I agree that I will reach out to my doctor prior to administering if I have any questions so that I can do it correctly\n\nType your full legal name below:',
    answer: {
      type: 'text',
      name: 'mdiEpithalon_confirmUnderstandContactDoctorQuestions'
    },
    extras: { mdiQuestionId: '727ebb24-2e43-45fa-98a8-a83593adbf43' }
  },
  {
    field: 'mdiEpithalon_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: { type: 'text', name: 'mdiEpithalon_firstMessageDoctor', rows: 4 },
    extras: { mdiQuestionId: '78e7746a-9726-4dcc-b910-9e38886095ff' }
  },
  {
    field: 'mdiEpithalon_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiEpithalonAnswerField = Partial<
  QuestionAnswerMap<typeof mdiEpithalonQuestions>
>;

export default mdiEpithalonQuestions;
